import React from 'react';
import { Link } from 'react-router-dom';

export default function StatusWidget(props) {
	function determineMakerColor(status) {
		if (status.includes('Active')) {
			return 'bg-green-500';
		} else if (status.includes('Pending')) {
			return 'bg-yellow-500';
		} else {
			return 'bg-red-500';
		}
	}

	return (
		<div className="inline-block">
			<div
				className={
					'h-2 w-2 rounded-full inline-block mb-0.5 mr-2 ' +
					determineMakerColor(props.status)
				}
			/>
			{
				<Link
					to={props.cta}
					key={props.key}
					state={props.state}
					className="group"
				>
					<span className="group-hover:underline">{props.status}</span>
				</Link>
			}
		</div>
	);
}
